import {isNotNil, pickBy} from 'ramda';
import {isEmptyArray} from 'ramda-adjunct';

import {CampaignFilter} from '@dms/api/shared';

import {Nullish} from 'shared/web';

// Drops the "no condition" values the form carries (nil, empty list) so that the payload and the
// change detection only see real conditions.
export const compactVehicleSelectionFilter = (filter: CampaignFilter | Nullish): CampaignFilter =>
  pickBy((value) => isNotNil(value) && !isEmptyArray(value), filter ?? {});
